<template>
  <div class="header-book">
    <div class="header-book-content">
      <div class="header-book-content-btn p-0 border-0">
        <button class="header-book-content-buttom bg-white" @click="openToggle()">
          <div class="header-book-content-btn-icons">
            <i class="bi bi-person"></i>
          </div>
          <div class="header-book-content-btn-text">
            <span class="--title-h"><b>Guest</b></span>
            <span>{{ $store.state.Details.adults }} Adults</span>,
            <span> {{ $store.state.Details.children }} children</span>
          </div>
        </button>
        <div class="select-guest" v-if="toggle">
          <div class="select-guest-header">
            <h2>Select Guests</h2>
            <div
              role="button"
              @click="closeToggle()"
              class="close-btn text-center"
            >
              &times;
            </div>
          </div>
          <div class="select-guest-body">
            <div class="select-guest-body-items">
              <span>Adults</span>
              <div class="select-guest-body-items-context">
                <button @click="Details.adults--">-</button>
                <input type="text" v-model="Details.adults" />
                <button @click="Details.adults++">+</button>
              </div>
            </div>
            <div class="select-guest-body-items">
              <span>Children</span>
              <div class="select-guest-body-items-context">
                <button @click="Details.children--">-</button>
                <input type="text" v-model="Details.children" />
                <button @click="Details.children++">+</button>
              </div>
            </div>
          </div>
          <hr />
          <div class="text-end">
            <button class="btn btn-dark" @click="closeToggle()">Apply</button>
          </div>
        </div>
      </div>
      <div class="header-book-content-btn">
        <div class="header-book-content-buttom">
          <!-- <div class="header-book-content-btn-icons">
            <i class="bi bi-person"></i>
          </div> -->
          <div class="header-book-content-btn-text">
            <a-range-picker
              :showTime="false"
              v-model="fechas"
              size="large"
              :value="hackValue || value"
              :disabled-date="disabledDate"
              @change="onChange"
              @openChange="onOpenChange"
              @calendarChange="onCalendarChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "Vuex";
import { reactive, computed, ref, toRefs } from "Vue";
export default {
  setup() {
    const store = useStore();
    const toggle = ref(false);
    const closeToggle = () => {
      toggle.value = false;
    };
    const openToggle = () => {
      toggle.value = true;
    };
    const Details = computed(() => store.state.Details);
    const fechas = ref();
    // Date
    const dates = ref();
    const value = ref();
    const hackValue = ref();

    const disabledDate = (current) => {
      if (!dates.value || dates.value.length === 0) {
        return false;
      }

      const tooLate =
        dates.value[0] && current.diff(dates.value[0], "days") > 7;
      const tooEarly =
        dates.value[1] && dates.value[1].diff(current, "days") > 7;
      return tooEarly || tooLate;
    };
    const onOpenChange = (open) => {
      if (open) {
        console.log(open);
        // dates.value = [];
        // hackValue.value = [];
      } else {
        hackValue.value = undefined;
      }
    };

    const onChange = (val) => {
      value.value = val;
      fechas.value = val;
      store.dispatch("AddDates", fechas.value);
    };

    const onCalendarChange = (val) => {
      dates.value = val;
      fechas.value = val;
      store.dispatch("AddDates", fechas.value);
    };

    return {
      Details,
      toggle,
      fechas,
      closeToggle,
      openToggle,
      dates,
      value,
      hackValue,
      disabledDate,
      onOpenChange,
      onChange,
      onCalendarChange,
    };
  },
};
</script>